import React from "react";
import "./BlogHero.css";
import blogHeroImage from "../../../../assets/images/Blog/bloghero.jpg";

const BlogHero = () => {
  return (
    <section className="blogHero" aria-label="Blog hero">
      <div className="blogHero-bg">
        <img
          src={blogHeroImage}
          alt=""
          className="blogHero-bgImage"
          draggable={false}
        />
      </div>

      <div className="blogHero-overlay" aria-hidden="true" />

      <div className="blogHero-inner">
        <h1>Our blog</h1>
      </div>
    </section>
  );
};

export default BlogHero;